import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PrepareEffects, SendEffects, UploadEffects } from '../store/effects';
import * as fromUploader from '../store/reducers';
import { DropboxCreatedModule } from './dropbox-created/dropbox-created.module';
import { LandingModule } from './landing/landing.module';
import { PrepareModule } from './prepare/prepare.module';
import { SendModule } from './send/send.module';
import { UploaderStandardComponent } from './uploader-standard.component';
import { UPLOADER_STANDARD_ROUTES } from './uploader-standard.routes';

@NgModule({
  declarations: [
    UploaderStandardComponent,
  ],
  imports: [
    CommonModule,
    LandingModule,
    PrepareModule,
    SendModule,
    SharedModule,
    DropboxCreatedModule,
    StoreModule.forFeature(fromUploader.uploaderFeatureKey, fromUploader.reducers),
    EffectsModule.forFeature([UploadEffects, PrepareEffects, SendEffects]),
    RouterModule.forChild(UPLOADER_STANDARD_ROUTES),
  ],
  exports: [
    UploaderStandardComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UploaderStandardModule {

  constructor() { }

}
